import { useGetOverdueInvoicesQuery } from "@/services/dashboard";

const useOverdueInvoices = () => {
  const { data, error, isLoading } = useGetOverdueInvoicesQuery();

  return {
    overdueInvoices: data?.data?.items || [],
    isLoading,
    error,
  };
};

export default useOverdueInvoices;
